import { render, staticRenderFns } from "./YiLianUserZXAuth.vue?vue&type=template&id=6242afe6&scoped=true"
import script from "./YiLianUserZXAuth.vue?vue&type=script&lang=js"
export * from "./YiLianUserZXAuth.vue?vue&type=script&lang=js"
import style0 from "./YiLianUserZXAuth.vue?vue&type=style&index=0&id=6242afe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6242afe6",
  null
  
)

export default component.exports